import { render } from "./Uploader.vue?vue&type=template&id=53eed964&ts=true"
import script from "./Uploader.vue?vue&type=script&lang=ts"
export * from "./Uploader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__